import { ArrowForward } from "@mui/icons-material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";
import { map } from "lodash";
import { useMemo } from "react";
import { CreateCampaignFileData } from "../../../types/campaign";
import { useStyles } from "./styles";

export function Review() {
  const styles = useStyles();
  const formik = useFormikContext<CreateCampaignFileData>();

  const translateRule = useMemo(() => {
    return { update: "Substituir valores existentes" };
  }, []);

  const RenderColumns = (item: any) => {
    return (
      <Stack key={item.column} direction="row" spacing={2}>
        <div style={{ width: "30%" }}>
          <Typography variant="subtitle2">{item.label}</Typography>
        </div>
        <div style={{ width: "100%", textAlign: "center" }}>
          <ArrowForward color="action" fontSize="small" />
        </div>
        <div style={{ width: "30%" }}>
          <Typography variant="subtitle2">{item.column}</Typography>
        </div>
      </Stack>
    );
  };

  return (
    <Stack spacing={4}>
      <Typography color="primary">Resumo</Typography>
      <Typography>Tipo de importação: Dados cadastrais</Typography>
      <Typography>Arquivo: {formik.values.fileName}</Typography>
      <Typography>Quantidade de linhas: {formik.values.fileRows}</Typography>
      <Typography>Regra: {translateRule[formik.values.rule]}</Typography>
      <Typography>
        Identificador: {formik.values.identificator?.column}
      </Typography>
      <Typography>Colunas</Typography>

      <div className={styles.rootOptions}>
        {map(formik.values.columns, (column) => RenderColumns(column))}
      </div>
    </Stack>
  );
}
